<template>
    <el-dialog class="common-dialog noHeader register-info-dialog" title="您所属的年代是?" :visible="isShowModal" :show-close="false">
        <div class="content">
            <div class="year-item" v-for="item in yearList"
                 :key="item.label"
                 :class="{'active': item.isActive}"
                 @click="select(item.label)">
                <span>{{item.label}}</span>
                <span>后</span>
            </div>
        </div>
        <el-button type="primary" size="full" @click="save()">下一步</el-button>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
    data() {
        return {
            yearList: [
                {label: '00', birthday: new Date('2005'), isActive: false},
                {label: '90', birthday: new Date('1995'), isActive: false},
                {label: '80', birthday: new Date('1985'), isActive: false},
                {label: '70', birthday: new Date('1975'), isActive: false},
                {label: '60', birthday: new Date('1965'), isActive: false},
                {label: '50', birthday: new Date('1955'), isActive: false}
            ]
        }
    },
    computed: {
        ...mapState(['loginStep', 'user']),
        isShowModal() {
            return this.loginStep === 'year';
        }
    },
    methods: {
        ...mapMutations(['setUserInfo', 'setLoginStep']),
        select(label) {
            for (let year of this.yearList) {
                year.isActive = year.label === label;
            }
        },
        save() {
            let selectedItem = this.yearList.find(item => item.isActive);
            if (!selectedItem) {
                this.$message.error('请选择年代');
                return;
            }
            this.setUserInfo({birthday: selectedItem.birthday});
            this.setLoginStep('company')
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    height: 16.25rem;
    color: #9ca2ab;

    .year-item {
        width: 30%;
        height: 7rem;
        line-height: 7rem;
        border: 1px solid #e6e6e6;
        cursor: pointer;
        &.active {
            color: #2472e8;
        }
        span:first-child {
            font-size: 3.6rem;
        }
        span:last-child {
            font-size: 1.2rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// app/view/login/LoginYear.vue